






















import { Component } from "vue-property-decorator";
import BasePage from "../base/BasePage";
import Header from "./Home/Header.vue";
import { Pages } from "@/enums/Pages";
import { BreadCrumb, globalStore } from "@/store/modules/GlobalStore";
import Business from "./Home/Business.vue";
import { Route } from "vue-router";
import { inForceStore } from "@/store/modules/InForceStore";
import {clientsStore } from "@/store/modules/ClientStore";
import { opportunityStore } from "@/store/modules/OpportunityStore";
import Clients from "./Home/Clients.vue";
import { opportunityStatusStore } from "@/store/modules/OpportunityStatusStore";

@Component({
  components: {
    Header,
    Business,
    Clients,
  },
})
export default class extends BasePage {
  page = Pages.DASHBOARD;
  title = "Clients";
  breadCrumbs = [new BreadCrumb("Dashboard")];
  panel = [0, 1, 2];

  async beforeRouteEnter(
    to: Route,
    from: Route,
    next: () => void
  ): Promise<void> {
    await inForceStore.getAll();
    await opportunityStore.getAll();
    await opportunityStatusStore.getAll();
    await clientsStore.getDocuments();
    await clientsStore.refreshStats();
    globalStore.setWelcomeBackFlag(false);
    next();
  }
}
